export default __webpack_public_path__ + "static/media/property_422.311a1f42.png";